import AWSCard from '../components/cloudPrep/aws/AWSCard';
import GCPCard from '../components/cloudPrep/gcp/GCPCard';
import MicrosoftCard from '../components/cloudPrep/microSoft/MicrosoftCard';
import { setSelectedCloud } from '../redux/Slices/CloudPrepSlice';
import { useAppDispatch, useAppSelector } from '../redux/store/hooks';

const CloudPrepPage = () => {
  const { selectedCloud } = useAppSelector(state => state.root.cloudPrep);
  const dispatch = useAppDispatch();
  const renderCards = () => {
    switch (selectedCloud) {
      case 'AMAZON_WEB_SERVICES':
        return <AWSCard />;
      case 'MICROSOFT_AZURE':
        return <MicrosoftCard />;
      case 'GOOGLE_CLOUD':
        return <GCPCard />;
      default:
        return (
          <p className='mt-6 text-center text-gray-500'>
            Please select a cloud provider above.
          </p>
        );
    }
  };

  return (
    <div className='mx-auto max-w-4xl p-6'>
      <div className='flex justify-center gap-4'>
        {[
          { id: 'AMAZON_WEB_SERVICES', label: 'AWS' },
          { id: 'MICROSOFT_AZURE', label: 'Microsoft Azure' },
          { id: 'GOOGLE_CLOUD', label: 'Google Cloud Platform' }
        ].map(cloud => (
          <button
            key={cloud.id}
            onClick={() => dispatch(setSelectedCloud(cloud.id))}
            className={`rounded-full border px-6 py-2 text-sm font-medium transition-all ${
              selectedCloud === cloud.id
                ? 'bg-primary text-white shadow-md'
                : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            {cloud.label}
          </button>
        ))}
      </div>

      {renderCards()}
    </div>
  );
};

export default CloudPrepPage;
